import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acl',
  templateUrl: 'acl.component.html',
  styleUrls: ['acl.component.css']
})
export class AclComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
